//
// ReportCollectionOwner.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "./TransportModelReference";

var ReportCollectionOwner = createModule("transport::ReportCollectionOwner", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    ,
    {
        reportReferences: [1],
    },
    ,
    ,
    {
        getReferenceToReport: [1,1],
        getReferenceToBaseReport: [1,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default ReportCollectionOwner;
